import TextImage from "./TextImage";
import BanksLists from "./BanksLists";
import Steps from "./Steps";
import ServicesBoxes from "./ServicesBoxes";
import Faq from "./Faq";
import Video from "./Video";
import Achievements from "./Achievements";
import PhoneContact from "../elements/PhoneContact";
import Benefits from "./Benefits";
import TitleTextButtons from "./TitleTextButtons";
import CommonQuestions from "./CommonQuestions";
import BannerBoxes from "./BannerBoxes";
import Terminology from "./Terminology";
import GoogleReviews from "./GoogleReviews";
import CalculateLoan from "./CalculateLoan";
import StaffSection from "./StaffSection";
import SimpleSection from "./SimpleSection";
import BlogTable from "./BlogTable";
import BlogRecommendations from "../elements/BlogPostRecommendations";
import OnlineApp from "./OnlineApp";
import Specs from "./Specs";
import Newsletter from "./Newsletter";
import Spitogatos from "./Spitogatos";
import FeaturedBlogPosts from "./FeaturedBlogPosts";

const components = {
  text_and_image_section: TextImage,
  bank_logos: BanksLists,
  steps: Steps,
  loan_categories: ServicesBoxes,
  faq: Faq,
  video_: Video,
  rhombus_section: Achievements,
  contact_info: PhoneContact,
  benefits: Benefits,
  title_text_buttons: TitleTextButtons,
  common_questions: CommonQuestions,
  banner_boxes: BannerBoxes,
  terminology_: Terminology,
  google_reviews: GoogleReviews,
  calculate_loan: CalculateLoan,
  staff_section: StaffSection,
  simple_section: SimpleSection,
  table: BlogTable,
  blog_recommendations: BlogRecommendations,
  online_application: OnlineApp,
  specs: Specs,
  newsletter: Newsletter,
  spitogatos: Spitogatos,
  featured_blog_posts: FeaturedBlogPosts,
};

export default components;
